export default {
  namespaced: true,
  state: () => ({
    staticUrl: null,
    baseUrl: null,
    wsUrl: null,
    height: null,
    width: null,
    navVisible: true,
    refreshHeight: 0,
    chatId: null,
    newMessage: null,
    newNotification: null,
    scrolledToBottom: 0
  }),
  getters: {
    staticUrl: state => state.staticUrl,
    baseUrl: state => state.baseUrl,
    navVisible: state => state.navVisible,
    wsUrl: state => state.wsUrl,
    height: state => state.height,
    width: stable => stable.width,
    chatId: state => state.chatId,
    newMessage: state => state.newMessage,
    newNotification: state => state.newNotification,
    refreshHeight: state => state.refreshHeight,
    scrolledToBottom: state => state.scrolledToBottom
  },
  mutations: {
    init (state) {
      state.staticUrl = process.env.VUE_APP_STATIC_URL
      state.baseUrl = process.env.VUE_APP_BASE_URL
      state.wsUrl = process.env.VUE_APP_WS_URL
    },
    setScrolledToBottom (state, val) {
      state.scrolledToBottom = val
    },
    setNavVisible (state, visible) {
      state.navVisible = visible
    },
    setHeight (state, height) {
      state.height = height
    },
    setWidth (state, width) {
      state.width = width
    },
    setChatId (state, chatId) {
      state.chatId = chatId
    },
    setNewMessage (state, message) {
      state.newMessage = message
    },
    setNewNotification (state, notification) {
      state.newNotification = notification
    },
    refreshHeight (state) {
      state.refreshHeight++
    }
  }
}
